/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type Complexity = (typeof Complexity)[keyof typeof Complexity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Complexity = {
  NORMAL: "NORMAL",
  COMPLEX: "COMPLEX",
  VERY_COMPLEX: "VERY_COMPLEX",
} as const;
